import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function PainPoints() {
  return <section className="py-20 md:py-32 px-4 bg-dark-card/30" data-id="element-188">
      <div className="max-w-4xl mx-auto" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-190">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-191">
            <BookOpen className="w-8 h-8 text-gold" data-id="element-192" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 text-white leading-tight" data-id="element-193">
            ¿Qué es Grecia Legendaria?
          </h2>
          <p className="text-xl text-gray-300 mb-6" data-id="element-194">
            Grecia Legendaria es una colección digital creada para descubrir la
            Antigua Grecia de una forma clara, entretenida y visual.
          </p>
          <p className="text-xl text-gray-300 mb-6" data-id="element-195">
            A través de sus módulos y bonos explorarás la mitología, los dioses
            del Olimpo, héroes legendarios, criaturas fantásticas, grandes
            misterios, ciudades históricas y el legado que esta extraordinaria
            civilización dejó al mundo.
          </p>
          <p className="text-xl text-gray-300" data-id="element-196">
            Todo el contenido fue desarrollado para despertar la curiosidad,
            ampliar la cultura general y convertir el descubrimiento en una
            experiencia fascinante, sin necesidad de conocimientos previos.
          </p>
        </motion.div>
      </div>
    </section>;
}